import { MainMenu, UserMenu, TitleBar } from '@/components';
import { api } from '_/services/api';
import { store } from '_/vuex/store';

/**
 * M2: monthly payout screen (scope §5). Payout is a BATCH (one action → one payout per
 * partner with pending commissions), which does not fit the native single-entry module
 * form — so it's a dedicated /cp screen: a live preview of who would be paid + how much
 * (GET /admin/payouts/preview, no persist) and an "Initiate" button that runs the batch
 * (POST /admin/payouts) — marking the commissions paid and notifying each partner.
 */
export default {
    name: 'InitiatePayout',

    components: { MainMenu, UserMenu, TitleBar },

    data() {
        const now = new Date();
        return {
            periodMonth: now.getMonth() + 1,
            periodYear: now.getFullYear(),
            preview: null,
            loading: false,
            initiating: false,
        };
    },

    created() {
        this.fetchPreview();
    },

    mounted() {
        // A custom screen must set up its own chrome like Dashboard does, otherwise the
        // layout inherits the previous route's state (e.g. stale 'dashboard-page' body
        // class with no wrapper positioning) and the page renders broken.
        this.$nextTick(() => {
            this.$store.dispatch('ui/setBodyClass', 'dashboard-page');
            this.$store.dispatch('ui/animateWrapper');
            this.$store.dispatch('ui/setTitle', 'Mesečna isplata');
        });
    },

    methods: {
        fetchPreview() {
            this.loading = true;
            api.get('admin/payouts/preview')
                .then((response) => { this.preview = response.data.body; })
                .catch(() => { this.preview = null; })
                .finally(() => { this.loading = false; });
        },

        initiate() {
            if (this.initiating || !this.preview || this.preview.count === 0) {
                return;
            }

            // Initiation is irreversible: it marks the commissions as paid and emails
            // every partner. Confirm first (native confirm, like the framework's own
            // delete actions), echoing count + total so the admin sees exactly what runs.
            const confirmed = window.confirm(
                'Pokrenuti mesečnu isplatu za ' + this.preview.count + ' partnera, ukupno €'
                + this.preview.total + '?\n\n'
                + 'Provizije će biti označene kao isplaćene i partnerima će biti poslat email. '
                + 'Ova akcija je nepovratna.'
            );
            if (!confirmed) {
                return;
            }

            this.initiating = true;

            api.post('admin/payouts', {
                period_month: this.periodMonth,
                period_year: this.periodYear,
            })
                .then((response) => {
                    const body = response.data.body;
                    store.dispatch('notification/addNotification', {
                        notification: {
                            subject: 'Isplata pokrenuta',
                            compiled_message: body.payouts_created + ' isplata, ukupno €' + body.total_disbursed,
                            type: 'success',
                        },
                    });
                    this.fetchPreview();
                })
                .catch((error) => {
                    store.dispatch('notification/addNotification', {
                        notification: {
                            subject: 'Greška',
                            compiled_message: (error.data && error.data.message) || 'Isplata nije pokrenuta.',
                            type: 'error',
                        },
                    });
                })
                .finally(() => { this.initiating = false; });
        },
    },
};
